import React, { useContext, useState } from "react";
import styled from "styled-components";

import { Button, Callout, PaneLayout, Toolbar } from "@examspark/common-ui";

import { BrowserContext } from "../../../../providers/BrowserContext";
import ResourceViewer from "../../../resources/ResourceViewer";

const StyledToolbar = styled(Toolbar)`
  padding: 1rem;
  border-bottom: solid 1px #ddd;
`;
const PreviewMain = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const PassagePickerPreview = () => {
  const [browser, dispatchBrowser] = useContext(BrowserContext);
  const [previewMode] = useState("content");

  return (
    <PaneLayout direction="vertical">
      <StyledToolbar>
        {/* <ToggleButtonGroup
          color="light-gray"
          value={previewMode}
          onClick={(value) => setPreviewMode(value as typeof previewMode)}
        >
          <ToggleButtonGroup.Button value="content">
            Content
          </ToggleButtonGroup.Button>
          <ToggleButtonGroup.Button value="standards">
            Standards
          </ToggleButtonGroup.Button>
          <ToggleButtonGroup.Button value="items">
            Items
          </ToggleButtonGroup.Button>
        </ToggleButtonGroup> */}
        <Toolbar.Flex />
        <Button
          title="Close Preview"
          onClick={() => {
            dispatchBrowser({ type: "CLEAR_FOCUSED" });
          }}
        >
          Close Preview
        </Button>
      </StyledToolbar>
      <PreviewMain>
        {previewMode === "content" && browser.focused && (
          <div style={{ padding: "1rem", margin: "0 auto", maxWidth: "50rem" }}>
            <ResourceViewer
              resourceKey={{
                sk: "resource#v0",
                id: browser.focused,
              }}
            />
          </div>
        )}
        {previewMode === "standards" && browser.focused && (
          <div style={{ padding: "1rem" }}>
            <Callout>Standards page coming soon.</Callout>
          </div>
        )}
        {previewMode === "items" && browser.focused && (
          <div style={{ padding: "1rem" }}>
            <Callout>Items page coming soon.</Callout>
          </div>
        )}
      </PreviewMain>
    </PaneLayout>
  );
};

export default PassagePickerPreview;
